export default "/images/check-icon-white.png?8b3760210598ac7313c4843aa32d64b2";